function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from './utils/highcharts';
// offline-exporting must be placed after the exporting module (from utils/highcharts)
import offlineExporting from 'highcharts/modules/offline-exporting';
import colors from './utils/colors';
import commonOptions from './utils/common_options';
var Chart = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    immutable,
    options,
    theme,
    type
  } = _ref;
  if (typeof Highcharts === 'object') {
    var _options$exporting;
    // @ts-expect-error offlineExporting types not present
    if (options !== null && options !== void 0 && (_options$exporting = options.exporting) !== null && _options$exporting !== void 0 && _options$exporting.offlineExporting) {
      offlineExporting(Highcharts);
    }
    Highcharts.setOptions(commonOptions({
      options,
      theme
    }));
  }
  var chartOptions = React.useMemo(() => _objectSpread({
    colors: colors({
      options,
      theme
    })
  }, options), [options, theme]);
  React.useEffect(() => {
    if (typeof Highcharts === 'object') {
      Highcharts.setOptions(commonOptions({
        options,
        theme
      }));
    }
  }, [options, theme]);
  return /*#__PURE__*/React.createElement(HighchartsReact, {
    constructorType: type,
    highcharts: Highcharts,
    immutable: immutable,
    options: chartOptions,
    ref: ref
  });
});
Chart.displayName = 'Chart';
export default Chart;